(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breed-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__breedVideoInit) return;
    window.__breedVideoInit = true;

    document.addEventListener('click', function (e) {
      var button = e.target.closest('.breed-video__play');
      if (!button) return;
      var frame = button.closest('[data-breed-video]');
      if (!frame) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(frame.dataset.breedVideo) + '?autoplay=1&rel=0';
      iframe.title = frame.dataset.breedVideoTitle || '';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      button.replaceWith(iframe);
      iframe.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  function initComparisonReveal() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-ct-reveal]:not(.comparison-table--js)').forEach(function(table) {
      table.classList.add('comparison-table--js');
      new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('comparison-table--revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 }).observe(table);
    });
  }
  initComparisonReveal();
  document.addEventListener('shopify:section:load', initComparisonReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      if (root.dataset.hiwInit) return;
      root.dataset.hiwInit = '1';

      var rail = root.querySelector('.how-it-works__rail');
      if (!rail) return;
      var tabs = Array.prototype.slice.call(rail.querySelectorAll('.how-it-works__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.how-it-works__panel'));
      if (!tabs.length || !panels.length) return;

      // The tab contract goes on here, with the handlers, never in the server markup (see the
      // comment on .how-it-works__desktop).
      rail.setAttribute('role', 'tablist');
      rail.setAttribute('aria-orientation', 'vertical');
      rail.setAttribute('aria-label', rail.dataset.label);
      tabs.forEach(function (tab, i) {
        tab.setAttribute('role', 'tab');
        tab.removeAttribute('aria-level');
        if (panels[i]) tab.setAttribute('aria-controls', panels[i].id);
      });
      panels.forEach(function (panel, i) {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
        if (tabs[i]) panel.setAttribute('aria-labelledby', tabs[i].id);
      });

      function activate(index, focus) {
        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        panels.forEach(function (panel, i) {
          if (!panel) return;
          if (i === index) { panel.removeAttribute('hidden'); }
          else { panel.setAttribute('hidden', ''); }
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(i, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) { e.preventDefault(); activate(next, true); }
        });
      });

      activate(0, false); // JS enhancement: collapse to single active panel
    }

    function initAll() {
      document.querySelectorAll('.how-it-works__desktop[data-how-it-works]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.how-it-works__desktop[data-how-it-works]');
      if (root) initTabs(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inflammaging"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__inflammagingInit) return;
    window.__inflammagingInit = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-inflammaging-open]');
      if (openBtn) {
        e.preventDefault();
        var tpl = document.getElementById(openBtn.getAttribute('data-inflammaging-open'));
        var PD = window.PageDrawer;
        if (!tpl || !PD || typeof PD.openWithContent !== 'function') return;
        // Drawer inherits this section's scheme so the modal panel and the drawer chrome are one unified colour.
        // The scheme class is set on the button in Liquid markup (data-inflammaging-scheme), so it is always present here.
        var SCHEME = openBtn.getAttribute('data-inflammaging-scheme');
        var dialog = document.getElementById('page-drawer-dialog');
        if (dialog && SCHEME) {
          dialog.classList.add(SCHEME, 'inflammaging-drawer');
          dialog.addEventListener('close', function restore() {
            dialog.classList.remove(SCHEME, 'inflammaging-drawer');
            dialog.removeEventListener('close', restore);
          });
        }
        PD.openWithContent(tpl.innerHTML, openBtn.getAttribute('data-inflammaging-title') || '');
        return;
      }

      var closeBtn = e.target.closest('[data-inflammaging-close]');
      if (closeBtn) {
        e.preventDefault();
        var afterId = closeBtn.getAttribute('data-inflammaging-close');
        if (window.PageDrawer && typeof window.PageDrawer.close === 'function') window.PageDrawer.close();
        // Prefer an explicit CTA anchor (e.g. the subscription widget, #subscribe,
        // which carries its own scroll-margin-top). Fall back to the next section.
        var targetId = closeBtn.getAttribute('data-inflammaging-cta-target');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) {
          var sec = document.getElementById('shopify-section-' + afterId);
          target = sec && sec.nextElementSibling;
        }
        if (target) {
          // 'instant', not 'smooth'/'auto': on desktop the page scrolls the
          // .page-wrapper squeeze container, where smooth scrollIntoView is a
          // no-op (the CTA would close the drawer but never reach #subscribe).
          // Instant scrolls reliably, honors scroll-margin-top, and is
          // reduced-motion-friendly. Delay lets the drawer finish closing first.
          setTimeout(function () { target.scrollIntoView({ behavior: 'instant', block: 'start' }); }, 400);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
